// utils/permissionUtils.js
import { MODULES } from "../Constants/appConstants";
import { PERMISSIONS } from "../Constants/storageConstant";
import {
  getLocalData,
  isAdmin,
  isCounsellor,
  isDoctor,
  isDoctorAssistant,
  isHospitalAdmin,
  isManager,
  isPharmacist,
  isReceptionist,
  isStaff,
  isTherapist,
} from "../Services/common";
import logger from "./logger";

const {
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  FINGERPRINT,
  TELECONSULT,
  VIEW_INVENTORY,
  SOAP,
  PHYSICAL_EXAMINATION,
  CUSTOM_BILLING_ITEM,
  VIEW_MEDICINE_SALE_RETURN,
  TPA_MODULE,
  DUE_TRACKER,
  EXPIRY_TRACKER,
} = MODULES;

const THERAPIST_PERMISSION = [DASHBOARD_MODULE];
const STAFF_PERMISSION = [DASHBOARD_MODULE];
const ADMIN_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  FINGERPRINT,
  VIEW_INVENTORY,
  SOAP,
  PHYSICAL_EXAMINATION,
  CUSTOM_BILLING_ITEM,
  VIEW_MEDICINE_SALE_RETURN,
  TPA_MODULE,
  DUE_TRACKER,
  EXPIRY_TRACKER,
];
const HOSPITAL_ADMIN_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  FINGERPRINT,
  VIEW_INVENTORY,
  SOAP,
  PHYSICAL_EXAMINATION,
  CUSTOM_BILLING_ITEM,
  VIEW_MEDICINE_SALE_RETURN,
  TPA_MODULE,
  DUE_TRACKER,
  EXPIRY_TRACKER,
];
const MANAGER_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  TRACK_REPORT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  CANCEL_BILL_MODULE,
  PATIENT_FOLDER,
  ALERT,
  MARKETING,
  SERVICE_ALERT,
  PATIENT_VISIT_ALERT,
  FINGERPRINT,
  VIEW_INVENTORY,
  SOAP,
  PHYSICAL_EXAMINATION,
  CUSTOM_BILLING_ITEM,
  VIEW_MEDICINE_SALE_RETURN,
  TPA_MODULE,
  DUE_TRACKER,
  EXPIRY_TRACKER,
];
const DOCTOR_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_IPD,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  PATIENT_FOLDER,
  FINGERPRINT,
  VIEW_INVENTORY,
  SOAP,
  PHYSICAL_EXAMINATION,
  CUSTOM_BILLING_ITEM,
  VIEW_MEDICINE_SALE_RETURN,
  TPA_MODULE,
  DUE_TRACKER,
];
const PHARMACIST_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  SERVICIES_MODULE,
  REPORTS_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  PATIENT_FOLDER,
  FINGERPRINT,
  VIEW_INVENTORY,
  SOAP,
  PHYSICAL_EXAMINATION,
  CUSTOM_BILLING_ITEM,
  VIEW_MEDICINE_SALE_RETURN,
  TPA_MODULE,
  DUE_TRACKER,
  EXPIRY_TRACKER,
];
const RECEPTION_PERMISSION = [
  DASHBOARD_MODULE,
  MEDICINES_MODULE,
  REPORTS_MODULE,
  SERVICIES_MODULE,
  ATTENDANCE_MODULE,
  VIEW_EXPANSE,
  VIEW_IPD,
  PATIENT_VISIT_ALERT,
  TELECONSULT,
  PATIENT_LISTING,
  DIAGNOSIS,
  BEFORE_AFTER,
  TREATMENT,
  VIEW_PRECRIPTION,
  TREATMENT_PLAN,
  VIEW_INVESTIGATION,
  DAMS_MODULE,
  VIEW_MEDICINE_PURCHASE_RETURN,
  PATIENT_FOLDER,
  FINGERPRINT,
  VIEW_INVENTORY,
  SOAP,
  PHYSICAL_EXAMINATION,
  CUSTOM_BILLING_ITEM,
  VIEW_MEDICINE_SALE_RETURN,
  DUE_TRACKER,
  TPA_MODULE,
];

const canAccessModule = (moduleName = "") => {
  let logObj = {
    request: moduleName,
    can_view: false,
    how: null,
    why_not: null,
  };

  const permissions = getLocalData(PERMISSIONS);

  if (!permissions) {
    logObj.can_view = false;
    logObj.how = null;
    logObj.why_not = "no permissions found";
    // eslint-disable-next-line no-console
    logger.log("[canAccessModule]", logObj);
    return false;
  }

  var $rolePermissions = [];
  if (isTherapist()) {
    $rolePermissions = THERAPIST_PERMISSION;
    logObj.how = "therapist role";
  }
  if (isStaff()) {
    $rolePermissions = STAFF_PERMISSION;
    logObj.how = "staff role";
  }
  if (isDoctor() || isDoctorAssistant()) {
    $rolePermissions = DOCTOR_PERMISSION;
    logObj.how = isDoctor() ? "doctor role" : "doctor assistant role";
  }
  if (isAdmin()) {
    $rolePermissions = ADMIN_PERMISSION;
    logObj.how = "admin role";
  }
  if (isHospitalAdmin()) {
    $rolePermissions = HOSPITAL_ADMIN_PERMISSION;
    logObj.how = "hospital admin role";
  }
  if (isManager()) {
    $rolePermissions = MANAGER_PERMISSION;
    logObj.how = "manager role";
  }
  if (isPharmacist()) {
    $rolePermissions = PHARMACIST_PERMISSION;
    logObj.how = "pharmacist role";
  }
  if (isReceptionist() || isCounsellor()) {
    $rolePermissions = RECEPTION_PERMISSION;
    logObj.how = isReceptionist() ? "receptionist role" : "counsellor role";
  }

  let hasAccess = false;
  if (Array.isArray(moduleName)) {
    hasAccess = moduleName.some((name) =>
      permissions.some(
        (p) =>
          (p?.name === name || `view_${name}` === p?.name) &&
          $rolePermissions &&
          $rolePermissions.includes(name),
      ),
    );
  } else {
    hasAccess = permissions.some(
      (p) =>
        (p?.name === moduleName || p?.name === `view_${moduleName}`) &&
        $rolePermissions &&
        $rolePermissions.includes(moduleName),
    );
  }

  logObj.can_view = hasAccess;

  if (!hasAccess) {
    if (!$rolePermissions || $rolePermissions.length === 0) {
      logObj.why_not = "no role permissions";
    } else if (Array.isArray(moduleName)) {
      logObj.why_not = `no matching permission for any in [${moduleName.join(", ")}]`;
    } else {
      logObj.why_not = "no matching permission for module";
    }
  }

  // eslint-disable-next-line no-console
  logger.log("[canAccessModule]", logObj);

  return hasAccess;
};

export default canAccessModule;

/**
 * "Does this hospital have the module enabled at all?" — checks
 * only the hospital-level Spatie permission set in localStorage,
 * deliberately *without* the role allowlist that `canAccessModule`
 * layers on top.
 *
 * Use this when you need a hospital-config truth (e.g. should the
 * Edit User form even render the per-user checkbox for a module?)
 * separately from "can THIS role use it" (which is the job of
 * canAccessModule).
 *
 * Accepts either the bare module key (`"medicines"`) or the
 * `view_<key>` form, since both shapes appear across the codebase.
 */
export const hospitalHasModule = (moduleName = "") => {
  if (!moduleName) return false;
  const permissions = getLocalData(PERMISSIONS);
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.some((p) => p?.name === moduleName || p?.name === `view_${moduleName}`);
};
